import { Button, Stack, Typography } from "@mui/material"
import { IProjectAuthorShort } from "../../api/types/projects"
import { IconLike } from "../../icons/IconLike"
import { IconLikeFilled } from "../../icons/IconLikeFilled"
import { COLORS } from "../../styles/variables"
import { formatNumber } from "../../common/FormatNumber"
import { StackedAvatars } from "../ui-kit/StackedAvatars"
import modalEmitter from "../ModalComponent/modalEmitter"
import { ProjectLikesModalBody } from "../Modals"

type Props = {
  projectId: number
  isLiked: boolean
  likesCount: number
  likesPreview?: IProjectAuthorShort[] | null
  onToggleLike: () => void
  loading?: boolean
}

export const ProjectLikeControl = ({
  projectId,
  isLiked,
  likesCount,
  likesPreview,
  onToggleLike,
  loading = false,
}: Props) => {
  const openLikesModal = () => {
    if (likesCount <= 0) return
    modalEmitter.emitOpenModal({
      dialog: {
        title: 'Лайки',
        body: <ProjectLikesModalBody projectId={projectId} />,
        modalToCentrPosition: true,
      },
    })
  }

  return (
    <Stack direction="row" alignItems="center" gap={1.5}>
      <Button
        variant="contained"
        color="secondary"
        onClick={onToggleLike}
        disabled={loading}
        sx={{
          minWidth: 44,
          maxHeight: 32,
          ...(isLiked
            ? {
                backgroundColor: COLORS.CATSKILL_WHITE,
                color: COLORS.BLACK,
                '&:hover': { backgroundColor: COLORS.LINK_WATER },
                '@media (hover: none)': {
                  '&:hover': { backgroundColor: COLORS.CATSKILL_WHITE },
                },
              }
            : {}),
        }}
      >
        {isLiked ? <IconLikeFilled fontSize="small" /> : <IconLike fontSize="small" />}
      </Button>

      <Stack
        direction="row"
        alignItems="center"
        gap={1}
        onClick={openLikesModal}
        sx={{ cursor: likesCount > 0 ? 'pointer' : 'default' }}
      >
        <StackedAvatars users={likesPreview ?? []} max={3} size={24} overlap={8} />
        <Typography variant="black-14-medium">{formatNumber(likesCount)}</Typography>
      </Stack>
    </Stack>
  )
}
